
<script>
  import noIconImg from '@/assets/service_icon/noicon.png'
  import remoteRackImg from '@/assets/service_icon/remoterack.png'
  import repliImg from '@/assets/service_icon/repli.png'
  import repliSellerPortalImg from '@/assets/service_icon/repli_seller_portal.png'
  import rudderImg from '@/assets/service_icon/rudder.png'

  export default {
    data: () => ({
      imageMap: {
        noicon: noIconImg,
        remoterack: remoteRackImg,
        repli: repliImg,
        repli_seller_portal: repliSellerPortalImg,
        rudder: rudderImg
      }
    }),
    methods: {
      image (iconFile, isPath = false) {
        if (iconFile) {
          return this.imageMap[iconFile.split('.')[0]]
        } else {
          return noIconImg
        }
      }
    }
  }
</script>
